module.exports = __webpack_public_path__ + "static/media/Mienfoo_gaussian2.14c6c57d.png";